import React, { ReactNode } from 'react';
import { Typography } from '@mui/material';

interface TabPanelProps {
  children?: ReactNode;
  index: number;
  value: number;
}

export const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      className="TAB_PANEL"
      // style={{ paddingTop: 8 }}
    >
      {value === index && <Typography>{children}</Typography>}
    </div>
  );
};
